import { RouterProvider } from 'react-router-dom';
import { AuthContext, useAdminAuthProvider } from '@/hooks/useAdminAuth';
import { router } from '@/router';

export default function App() {
  const auth = useAdminAuthProvider();

  return (
    <AuthContext.Provider value={auth}>
      <RouterProvider router={router} />
    </AuthContext.Provider>
  );
}
